import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export interface ContactSubmission {
  name: string;
  email: string;
  message: string;
}

class ContactService {
  static async submit(data: ContactSubmission): Promise<void> {
    console.log('[ContactService] submit:start', {
      nameLen: data.name?.length ?? 0,
      emailLen: data.email?.length ?? 0,
      messageLen: data.message?.length ?? 0,
    });

    await addDoc(collection(db, 'contact_submissions'), {
      name: data.name,
      email: data.email,
      message: data.message,
      createdAt: serverTimestamp(),
      source: 'portfolio',
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    });

    console.log('[ContactService] submit:success');
  }
}

export default ContactService;
